import "./styles.modules.scss";

import React from "react";
import { AiFillHome as HomeIco } from "react-icons/ai";
import { BsTrash as TrashIco } from "react-icons/bs";
import { CircularProgress } from "@material-ui/core";

const BreadCrumbCategories = (props) => {
  const { edit = true, trashEvent, catalog } = props;
  const limit = 20;

  const limitText = (text) => {
    const newText = text.length > limit ? `${text.substr(0, limit)}...` : text;
    return newText;
  };
  const parentNodes = catalog.parentNodes
    .filter((it, indice) => {
      return indice > 0;
    })
    .map((it) => {
      return limitText(it && it.title ? it.title : "");
    });

  const parentF = parentNodes.length > 0 ? parentNodes.join(" / ") + " / " : "";
  const stringParentNodes = parentF + limitText(catalog && catalog.title ? catalog.title : "");

  return (
    <div className={`KEBreadCrumb mig ${edit ? "migEdit" : ""}`}>
      <div className="migText">
        <HomeIco /> raiz: {stringParentNodes}
      </div>
      {edit && (
        <div className="migBtns">
          <div
            className="trashBtn"
            onClick={() => {
              trashEvent(catalog);
            }}
            disabled={props.loading}
          >
            {props.loading ? <CircularProgress size={15} /> : <TrashIco />}
          </div>
        </div>
      )}
    </div>
  );
};

export default BreadCrumbCategories;
